import { useQuery } from "@tanstack/react-query";
import React from 'react';
import { useSwiperSlide } from 'swiper/react';
import { Helmet } from 'react-helmet';
import {
    MEDIA_KEY,
    MEDIA_SET_COUNT_KEY,
    fetchMedia,
    setMediaCountViews
} from "../../../../../api/public-voissa/medias";
import useMediaLocked from '../../../../../hooks/useMediaLocked';
import { canonical, cropText, isNoFollowMedia, legendToTitle } from '../../../../../libs/helper';
import './AdvancedMediaViewerItem.scss';
import AdvancedMediaViewerLocked from '../AdvancedMediaViewerLocked/AdvancedMediaViewerLocked';
import AdvancedMediaViewerVideo from '../AdvancedMediaViewerVideo/AdvancedMediaViewerVideo';
import AdvancedMediaViewerImage from '../AdvancedMediaViewerImage/AdvancedMediaViewerImage';
import createLink from "../../../../../libs/createLink";

const MetaSeo = ({media})=>{
    if(!media?.legend) return null;
    const urlCanonical = canonical(createLink(media.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...media.owner, media}), "", "mediaviewver");
    return (
        <Helmet>
            <title>{media.kind === 'video' ? 'Vidéo' : "Photo"} {legendToTitle(media?.legend || "")} ({media.album && media.album.title ? media.album.title : ''}) - Voissa</title>
            <meta name="description" content={cropText(media.legend, 130)} />
            <link rel="canonical" href={urlCanonical} />
            {/*metaLeywords && (<meta name="keywords" content={metaLeywords} />)*/}
            {isNoFollowMedia(media) ? <meta name="robots" content="noindex" /> : null}
        </Helmet>
    );
}


const AdvancedMediaViewerItem = ({ 
    media, 
    coverMode,
    toggleSlider,
    setToggleSlider,
    handleClose = () =>{}
}) => {
    const {
        isActive,
        isNext,
        isPrev,
        isVisible
    } = useSwiperSlide();
    const enabled = isActive || isNext || isPrev || isVisible;
    // const enabled = isActive;

    
    const {data : hydratedMedia, isFetched : mediaIsFetched} = useQuery(
        [MEDIA_KEY, media._id],
        ()=> fetchMedia(media._id),
        {
            enabled,
            initialData: media
        }
    );

    useQuery(
        [MEDIA_SET_COUNT_KEY, hydratedMedia._id],
        ()=> setMediaCountViews(hydratedMedia._id),
        {
            staleTime : (1000 * 60 * 60),
            cacheTime : (1000 * 60 * 60),
            retry : false,
            enabled : !!hydratedMedia._id && mediaIsFetched && isActive
        }
    );

    const {lockedReason, handleLockedAction} = useMediaLocked(hydratedMedia);
    if(!enabled) return null;
    else if(lockedReason) return <AdvancedMediaViewerLocked 
        media={media} 
        setToggleSlider={setToggleSlider} 
        lockedReason={lockedReason} 
        handleClose={handleClose}
        handleLockedAction={handleLockedAction}/>;

    return (
        <>
            {isActive && <MetaSeo media={hydratedMedia}/>}
            {(media.kind === 'video' )
                ? <AdvancedMediaViewerVideo 
                    media={hydratedMedia} 
                    isActive={isActive} 
                    coverMode={coverMode}
                    setToggleSlider={setToggleSlider} 
                    toggleSlider={toggleSlider} 
                    handleClose={handleClose}/>
                : <AdvancedMediaViewerImage 
                    media={hydratedMedia} 
                    coverMode={coverMode} 
                    isActive={isActive}
                    setToggleSlider={setToggleSlider} 
                    toggleSlider={toggleSlider} 
                    handleClose={handleClose}/>
            }
        </>
    );
};


export default AdvancedMediaViewerItem;
